<template>
	<div class="leftres">
		<div>
			<div :class=" showorhide ? 'inputtop' : 'inputtops' ">
				<div v-for="(item , index) of formdata" :key="index" style="display: inline-block;">
					<Commondropdownlist ref="secRefs" :options="item.options" :lablewith="item.lablewith"
						:inputdata="item.inputdata" :title="item.title" :fontSize="item.fontSize" :color="item.color"
						:placeholder="item.placeholder" :types="item.types" :inputtype="item.inputtype"
						:width="item.width" @change1="startTime" @change2="endTime"></Commondropdownlist>
				</div>
				<div :class=" showorhide ? 'Btngroups' : 'Btngroup' ">
					<CommonBtngroup :show="showorhide" @showclick="showclick" @hide="hide" @select="select"
						@reset="reset"></CommonBtngroup>
				</div>
				<div style="height:10px;">
				</div>
			</div>
			<div class="TableBox"
				style=" box-shadow: 0px 1px 4px 0px rgba(0, 0, 0, 0.1); margin-top: 10px; background-color: #FFFFFF;">
				<Secondarychecktable ref="sectable" :tableData="tableData" :total="total" @SeExport="SeExport"
					@handleCurrentChange="handleCurrentChange" @handleSizeChange="handleSizeChange">
				</Secondarychecktable>
			</div>
			<Dialog width="420px" title="提示信息" :dialogVisible="dialogVisibles" @cancel="cancel" @dialogOK="dialogOK"
				:src="'../assets/icon/icon-errors.png'">
				<span
					style="display: inline-block;position: absolute; top: 50px; left: 50px; font-size: 14px;color: #666666;">确认要重置选中账号的密码吗？</span>
			</Dialog>
		</div>
	</div>
</template>

<script>
	import Commondropdownlist from '../../../../components/common-dropdownlist.vue'
	import CommonBtngroup from '../../../../components/commongroup.vue'
	import Dialog from '../../../../components/dialog.vue'
	import Secondarychecktable from './components/secondarychecktable.vue'
	import utils from '../../../../common/utils'
	import {
		Check2InvoiceList,
		Check2InvoiceExport,
		HelperU8InterfaceStatus,
		InventoryClassList
	} from '@/api/home'
	export default {
		components: {
			Commondropdownlist,
			CommonBtngroup,
			Dialog,
			Secondarychecktable
		},
		data() {
			return {
				tableData: [],
				total: 1,
				pageindex: 1,
				pageSize: 20,
				dialogVisibles: false,
				showorhide: true,
				formdata: [{
						inputdata: '',
						title: '经销商名称',
						fontSize: '14px',
						color: '#333333',
						placeholder: '请输入',
						types: '',
						inputtype: 'input',
						width: '210px',

					},
					{
						inputdata: '',
						title: '发票号',
						fontSize: '14px',
						color: '#333333',
						placeholder: '请输入',
						types: 'text',
						inputtype: 'input',
						width: '210px',
						lablewith: '80px'
					},
					{
						inputdata: "",
						title: "开票日期",
						fontSize: "14px",
						color: "#333333",
						placeholder: "请输入",
						types: "",
						inputtype: "date",
						width: "140px",
					},
					{
						inputdata: '',
						title: '状态',
						fontSize: '14px',
						color: '#333333',
						placeholder: '全部',
						types: '',
						inputtype: 'select',
						width: '220px',
						options: []
					},
					{
						inputdata: '',
						title: '次数区间',
						fontSize: '14px',
						color: '#333333',
						placeholder: '请输入',
						types: '',
						inputtype: 'numbers',
						width: '74px',
						lablewith: '95px',
						minleft: 0,
						maxleft: undefined,
						minrigth: 0,
						maxrigth: undefined
					},
					{
						inputdata: '',
						title: '产品线',
						fontSize: '14px',
						color: '#333333',
						placeholder: '请选择',
						types: '',
						inputtype: 'select',
						width: '220px',
						options: [],
						lablewith: '115px',
					},
					{
						inputdata: '',
						title: '错误信息',
						fontSize: '14px',
						color: '#333333',
						placeholder: '请输入',
						types: 'text',
						inputtype: 'input',
						width: '210px',
						lablewith: '80px'
					},
					{
						modelvalue: 2,
						inputdata: 2,
						title: '校验类型',
						fontSize: '14px',
						color: '#333333',
						placeholder: '全部',
						types: '',
						inputtype: 'select',
						width: '220px',
						options: [{
							key: 2,
							value: '二次校验'
						}, {
							key: 3,
							value: '三次校验'
						}, {
							key: 4,
							value: '四次校验'
						}]
					},
					{
						inputdata: "",
						title: "首次校验时间",
						fontSize: "14px",
						color: "#333333",
						placeholder: "请输入",
						types: "",
						inputtype: "date",
						width: "140px",
						lablewith: "100px",
					},
					{
						inputdata: "",
						title: "最终校验时间",
						fontSize: "14px",
						color: "#333333",
						placeholder: "请输入",
						types: "",
						inputtype: "date",
						width: "140px",
						lablewith: "100px",
					}
				],
				from: {
					cusName: "",
					invoiceNo: "",
					status: "",
					SBDate1: "",
					SBDate2: "",
					CreateTime1: "",
					CreateTime2: "",
					SynTime1: "",
					SynTime2: "",
					CheckTimeCount1: "",
					CheckTimeCount2: "",
					SynMessage: '',
					CheckType: 2,
				}
			}
		},
		mounted() {
			this.check2InvoiceList()
			this.helperU8InterfaceStatus()
			this.inventoryClassList();
		},
		methods: {
			async inventoryClassList() {
				let {
					code,
					data
				} = await InventoryClassList({})
				if (code == 0) {
					this.formdata[5].options = []
					data.data.map((item, index) => {
						this.formdata[5].options.push({
							key: item.InvClass,
							value: item.InvClassName
						})
					})
				}
			},
			async check2InvoiceList() {
				const loading = this.$loading({
					lock: true,
					text: '正在加载列表中...',
					spinner: 'el-icon-loading',
					background: 'rgba(255,255,255,0.3)'
				});
				let {
					data,
					code
				} = await Check2InvoiceList({
					cusName: this.from.cusName,
					invoiceNo: this.from.invoiceNo,
					status: this.from.status,
					SBDate1: this.from.SBDate1,
					SBDate2: this.from.SBDate2,
					CreateTime1: this.from.CreateTime1,
					CreateTime2: this.from.CreateTime2,
					SynTime1: this.from.SynTime1,
					SynTime2: this.from.SynTime2,
					CheckTimeCount1: this.from.CheckTimeCount1,
					CheckTimeCount2: this.from.CheckTimeCount2,
					InvClass: this.from.InvClass,
					SynMessage: this.from.SynMessage,
					CheckType: this.from.CheckType,
					pageSize: this.pageSize,
					pageIndex: this.pageindex
				})
				if (code == 0) {
					this.total = data.Count
					if (data.data) {
						this.tableData = data.data
						loading.close();
					}
					loading.close();
				}
				loading.close();
			},
			// 导出
			async check2InvoiceExport() {
				let resexprot = await Check2InvoiceExport({
					cusName: this.from.cusName,
					invoiceNo: this.from.invoiceNo,
					status: this.from.status,
					SBDate1: this.from.SBDate1,
					SBDate2: this.from.SBDate2,
					CreateTime1: this.from.CreateTime1,
					CreateTime2: this.from.CreateTime2,
					SynTime1: this.from.SynTime1,
					SynTime2: this.from.SynTime2,
					CheckTimeCount1: this.from.CheckTimeCount1,
					CheckTimeCount2: this.from.CheckTimeCount2,
					InvClass: this.from.InvClass,
					SynMessage: this.from.SynMessage,
					CheckType: this.from.CheckType,
					pageSize: this.pageSize,
					pageIndex: this.pageindex
				})
				if (resexprot) {
					//console.log(resexprot);
					if (resexprot.code == 999) {
						this.$message({
							type: "warning",
							message: resexprot.message
						})
					}
					let date = new Date()
					let str = `${date.getFullYear()}-${date.getMonth() + 1}-${date.getDate()}-${date.getTime()}`
					utils.downloadFile(resexprot, `发票校验${str}`, "xlsx")
				} else {
					// 返回json
					this.$message.warning('导出失败');
				}
			},
			SeExport() {
				this.check2InvoiceExport()
			},
			reset() {
				this.$refs.secRefs.forEach((item, index) => {
					if (index == 2 || index == 8 || index == 9) {
						item.startTime = ""
						item.endTime = ""
					}
					item.modelvalue = ""
				})
			},
			// 接口状态下拉
			async helperU8InterfaceStatus() {
				let {
					code,
					data
				} = await HelperU8InterfaceStatus({})
				this.formdata[3].options = []
				data.map((item, index) => {
					let obj = {
						key: item.Value,
						value: item.Text
					}
					this.formdata[3].options.push(obj)
				})
			},
			select() {
				this.pageindex = 1
				try {
					this.from.cusName = this.$refs.secRefs[0].modelvalue
					this.from.invoiceNo = this.$refs.secRefs[1].modelvalue
					this.from.SBDate1 = this.$refs.secRefs[2].startTime
					this.from.SBDate2 = this.$refs.secRefs[2].endTime
					this.from.status = this.$refs.secRefs[3].modelvalue
					this.from.CheckTimeCount1 = this.$refs.secRefs[4].modelvalueleft
					this.from.CheckTimeCount2 = this.$refs.secRefs[4].modelvalueright
					this.from.InvClass = this.$refs.secRefs[5].modelvalue
					this.from.SynMessage = this.$refs.secRefs[6].modelvalue
					this.from.CheckType = this.$refs.secRefs[7].modelvalue
					this.from.CreateTime1 = this.$refs.secRefs[8].startTime
					this.from.CreateTime2 = this.$refs.secRefs[8].endTime
					this.from.SynTime1 = this.$refs.secRefs[9].startTime
					this.from.SynTime2 = this.$refs.secRefs[9].endTime
					this.check2InvoiceList()
				} catch (error) {
					this.check2InvoiceList()
				}
			},
			cancel() {
				//console.log('name')
				this.dialogVisibles = false
			},
			dialogOK() {
				//console.log('name2')
				this.dialogVisibles = false
			},
			startTime(val) {
				//console.log("开始时间", val);
			},
			endTime(val) {
				//console.log("结束时间", val);
			},

			hide() {
				this.showorhide = false
				//console.log("askdas", this.showorhide)

			},
			showclick() {
				this.showorhide = true
			},
			handleCurrentChange(pageindex) {
				this.pageindex = pageindex
				this.check2InvoiceList()
			},
			handleSizeChange(paegSzie) {
				this.pageSize = paegSzie
				this.check2InvoiceList()
			},
		}
	}
</script>

<style lang="less" scoped>
	// .inputtop {
	// 	width: 980px;
	// 	height: 100px;
	// 	box-shadow: 0px 1px 4px 0px rgba(0, 0, 0, 0.1);
	// 	background-color: #ffffff;
	// 	padding-top: 15px;
	// 	padding-bottom: 70px;
	// 	transition: all .3s;
	// 	overflow: hidden;
	// }

	.inputtops {
		width: 980px;
		height: 80px;
		box-shadow: 0px 1px 4px 0px rgba(0, 0, 0, 0.1);
		background-color: #ffffff;
		padding-top: 15px;
		padding-bottom: 64px;
		overflow: hidden;
		transition: all .3s;
	}

	.inputtop {
		width: 980px;
		height: 100px;
		box-shadow: 0px 1px 4px 0px rgba(0, 0, 0, 0.1);
		background-color: #ffffff;
		padding-top: 15px;
		padding-bottom: 65px;
		// animation: shows 0.05s ease-in;
		overflow: hidden;
		position: relative;
	}

	.Btngroup {
		display: inline-block;
		float: right;
		margin-right: 20px;
		width: 400px;
		height: 50px;
		background-color: #ffffff;
		position: relative;
		bottom: 45px;
	}

	.Btngroups {
		display: inline-block;
		float: right;
		margin-top: 5px;
		margin-right: 10px;
	}
</style>